import Hammer from 'hammerjs';

class Slides
{
    index = 0;

    transitioning = false;

    paused = true;

    _listeners = new Map();

    _listener = null;

    constructor(elements, options = {})
    {
        this.elements = elements;

        this.options = Object.assign({
            threshold: 30,
            wait: 1000
        }, options);

		if(window.navigator.appVersion.toLowerCase().indexOf('windows') > -1 && window.navigator.userAgent.toLowerCase().indexOf('firefox') > -1) {
        	this.options.threshold = 2;
    	}
    }

    reset()
    {
        this.index = 0;

        this.elements.forEach((element, index) => {
            if (index > 0) {
                element.classList.remove('active');
            }
        });

        this.elements[0].parentNode.setAttribute('data-active', this.index);
    }

    on(label, cb)
    {
        this._listeners.has(label) || this._listeners.set(label, []);
        this._listeners.get(label).push(cb);
    }

    emit(label, ...args)
    {
        let listeners = this._listeners.get(label);

        if (listeners && listeners.length) {
            listeners.forEach((listener) => {
                listener(...args);
            });

            return true;
        }

        return false;
    }

    next()
    {

    }

    pause()
    {
        this.paused = true;
    }

    listen()
    {
        this.paused = false;

        if (! this._listener) {
            this._setupListener();
        }
    }

    _setupListener()
    {
        if (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch) {
            this._setupMobileListener();
        } else {
            this._setupBrowserListener();
        }

        this._listener = true;
    }

    _setupMobileListener()
    {
        let manager = new Hammer.Manager(this.elements[0].parentNode);
        manager.add(new Hammer.Swipe({event: 'animateSlide', direction: Hammer.DIRECTION_VERTICAL}));

        manager.on('animateSlide', (e) => {
            let index;

            if(e.direction == Hammer.DIRECTION_DOWN) {
                index = this.index + -1;
            } else {
                index = this.index + 1;
            }

            this.emit('transition', index, this.index);

            this.go(index);
        });
    }

    _setupBrowserListener()
    {
        window.addEventListener('wheel', (e) => {
            if (this.paused || this.transitioning) {
                return;
            }

            let index = this.index + (e.deltaY > 0 ? 1 : -1);
            this.emit('transition', index, this.index);

            if (e.deltaY > Math.abs(this.options.threshold) * -1 && e.deltaY < this.options.threshold) {
                return false;
            }

            this.go(index);
        });
    }

    go(index)
    {
        if (this.paused || this.transitioning) {
            return;
        }

        this.transitioning = true;

        if (index > -1 && index < this.elements.length) {
            // continue the chain.
            if (index > this.index) {
                this.elements[index].classList.add('active');
            } else {
                this.elements[index + 1].classList.remove('active');
            }

            this.elements[0].parentNode.setAttribute('data-active', index);

            this.index = index;
        } else {
            this.emit('done', index < 0 ? 'up' : 'down');
        }

        setTimeout(() => {
            this.transitioning = false;
        }, this.options.wait);
    }

    next()
    {
        this.go(this.index + 1);
    }

    prev()
    {
        this.go(this.index - 1);
    }
}

export default Slides;
